import angular from 'angular';
import 'angular-sanitize';
import 'ui-select';
import 'api-check';
import 'checklist-model';
import 'angular-formly';
import inLastDaysInputTemplate from '../templates/formly/inLastDaysInput.html';
import dateInputTemplate from '../templates/formly/dateInput.html';
import timeInputTemplate from '../templates/formly/timeInput.html';
import fieldTemplate from '../templates/formly/field.html';
import checkboxTemplate from '../templates/formly/checkbox.html';
import inputTemplate from '../templates/formly/input.html';
import inputDebouncedTemplate from '../templates/formly/input-debounced.html';
import moneyTemplate from '../templates/formly/money.html';
import textareaTemplate from '../templates/formly/textarea.html';
import radioTemplate from '../templates/formly/radio.html';
import radioAndOrTemplate from '../templates/formly/radioAndOr.html';
import uiSelectTemplate from '../templates/formly/uiSelect.html';
import uiSelectFilteredTemplate from '../templates/formly/uiSelectFiltered.html';
import uiSelectMultipleTemplate from '../templates/formly/uiSelectMultiple.html';
import uiSelectMultipleFilteredTemplate from '../templates/formly/uiSelectMultipleFiltered.html';
import uiSelectMultipleTaggingTemplate from '../templates/formly/uiSelectMultipleTagging.html';
import checkbuttonMultipleTemplate from '../templates/formly/checkbuttonMultiple.html';
import toggleButtonTemplate from '../templates/formly/toggleButton.html';

export default angular.module('app.configs.formly', [
  'checklist-model',
  'formly',
  'ui.select',
  'ngSanitize'
])
.run(function (formlyConfig, $filter) {
  let translate = $filter('translate');

  formlyConfig.extras.getFieldId = function (options) {
    if (options.id) {
      return options.id;
    }

    return options.key;
  };

  formlyConfig.setWrapper({
    name: 'field',
    template: fieldTemplate
  });

  formlyConfig.setType({
    name: 'checkbox',
    template: checkboxTemplate,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'input',
    template: inputTemplate,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'inputDebounced',
    template: inputDebouncedTemplate,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'money',
    template: moneyTemplate,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'textarea',
    template: textareaTemplate,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'toggleButton',
    template: toggleButtonTemplate
  });

  formlyConfig.setType({
    name: 'dateInput',
    template: dateInputTemplate,
    wrapper: ['field'],
    defaultOptions: {
      templateOptions: {
        template: null
      }
    }
  });

  formlyConfig.setType({
    name: 'timeInput',
    template: timeInputTemplate,
    wrapper: ['field'],
    defaultOptions: {
      templateOptions: {
        showMeridian: false,
        hourStep: 1,
        minuteStep: 15
      },
      controller: /*@ngInject*/ function ($scope) {
        $scope.clicked = function (e) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }
  });

  formlyConfig.setType({
    name: 'inLastDaysInput',
    template: inLastDaysInputTemplate,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'radioAndOr',
    template: radioAndOrTemplate,
    wrapper: ['field'],
    defaultOptions: function(options) {
      return {
          templateOptions: {
            options: ['$and', '$or', '$grouped_and', '$grouped_or'].map(value => {
              return {value: value, name: translate('$rule.' + value)};
            })
          }
      }
    }
  });

  formlyConfig.setType({
    name: 'radio',
    template: radioTemplate,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'radioSwitch',
    template: `<gg-switch name='{{id}}' options="to.options" ng-model="model[options.key]">`,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'labeledRadioSwitch',
    template: `
      <div class="tableize u-pv">
        <div class="tableize__cell"><span class="c-text c-text--normal c-text--faded">{{ to.label }}</span><a class="o-btn c-btn c-btn--icon has-tooltip u-ml--">
            <svg role="img" class="o-icon">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="icons/icons.svg#icon-info"></use>
            </svg><span data-title="{{ to.tooltipText }}" class="c-tooltip c-tooltip--top"></span></a></div>
        <div class="tableize__cell text-right">
          <gg-switch name='{{id}}' options="to.options" ng-model="model[options.key]">
        </div>
      </div>`
  });

  formlyConfig.setType({
    name: 'uiSelect',
    template: uiSelectTemplate,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'uiSelectFiltered',
    template: uiSelectFilteredTemplate,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'uiSelectMultiple',
    template: uiSelectMultipleTemplate,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'uiSelectMultipleFiltered',
    template: uiSelectMultipleFilteredTemplate,
    wrapper: ['field']
  });

  formlyConfig.setType({
    name: 'uiSelectMultipleTagging',
    template: uiSelectMultipleTaggingTemplate,
    wrapper: ['field']
  });

  // see https://github.com/formly-js/angular-formly-templates-bootstrap/blob/master/src/types/multiCheckbox.js
  // and https://github.com/formly-js/angular-formly-templates-bootstrap/issues/19#issuecomment-151139328
  formlyConfig.setType({
    name: 'checkbuttonMultiple',
    template: checkbuttonMultipleTemplate,
    wrapper: ['field'],
    controller: /* @ngInject */ function ($scope) {
      const to = $scope.to;
      const opts = $scope.options;
      $scope.multiCheckbox = {
        checked: [],
        hasChecked: hasChecked,
        change: setModel
      };

      // initialize the checkboxes check property
      $scope.$watch('model', function modelWatcher(newModelValue) {
        let modelValue, valueProp;

        if (Object.keys(newModelValue).length) {
          modelValue = newModelValue[opts.key];

          $scope.$watch('to.options', function optionsWatcher(newOptionsValues) {
            if (newOptionsValues && Array.isArray(newOptionsValues) && Array.isArray(modelValue)) {
              valueProp = to.valueProp || 'value';
              for (let index = 0; index < newOptionsValues.length; index++) {
                $scope.multiCheckbox.checked[index] = modelValue.indexOf(newOptionsValues[index][valueProp]) !== -1;
              }
            }
          });
        }
      }, true);

      function checkValidity(expressionValue) {
        let valid;

        if ($scope.to.required) {
          valid = angular.isArray($scope.model[opts.key]) &&
            $scope.model[opts.key].length > 0 &&
            expressionValue;

          $scope.fc.$setValidity('required', valid);
        }
      }

      function hasChecked() {
        return $scope.multiCheckbox.checked.indexOf(true) > -1;
      }

      function setModel() {
        $scope.model[opts.key] = [];
        angular.forEach($scope.multiCheckbox.checked, (checkbox, index) => {
          if (checkbox) {
            $scope.model[opts.key].push(to.options[index][to.valueProp || 'value']);
          }
        });

        // Must make sure we mark as touched because only the last checkbox due to a bug in angular.
        $scope.fc.$setTouched();
        checkValidity(true);
      }

      if (opts.expressionProperties && opts.expressionProperties['templateOptions.required']) {
        $scope.$watch(function () {
          return $scope.to.required;
        }, function (newValue) {
          checkValidity(newValue);
        });
      }

      if ($scope.to.required) {
        let unwatchFormControl = $scope.$watch('fc', function (newValue) {
          if (!newValue) {
            return;
          }
          checkValidity(true);
          unwatchFormControl();
        });
      }
    }
  });

  formlyConfig.setType({
    name: 'uiDeleteButton',
    template: `
    <a class="o-btn c-btn c-btn--icon c-btn--danger {{to.className || ''}}"
       ng-click="to.onClick && to.onClick(null, null, this)"
       ng-if="!to.hide">
      <span gg-icon="icon-trash"></span>
    </a>
  `,
    wrapper: null
  });
})



/** WEBPACK FOOTER **
 ** ./src/configs/formly.config.js
 **/